import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-turns-form-access-list-card',
  templateUrl: './turns-form-access-list-card.component.html',
  styleUrls: ['./turns-form-access-list-card.component.scss']
})
export class TurnsFormAccessListCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form;
  @Input() accessListKeys;
  accessListForm = new FormGroup({
    accessListEnable: new FormControl(false),
    checkListUserAccount: new FormControl(false),
    accessValue: new FormControl(null)
  });
  filterKey = '';
  updateAccessListFormSubscription: Subscription;
  addNewFormAccessValueSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public inputChange(formControlName) {
    this.submitForm();
  }

  public submitForm() {
    this.updateAccessListFormSubscription = this.formsTurnsService.updateFormAccessListFlags(this.form.InternalId, this.accessListForm.get('accessListEnable').value, this.accessListForm.get('checkListUserAccount').value).subscribe(
      (res) => {
        this.snackbarService.open(res['message'], 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['message'], 'error');
        this.formsTurnsService.refreshForm();
      }
    );
  }



  public filter(event) {
    this.filterKey = event.target.value;
  }

  public addAccessListKey() {
    if (this.accessListForm.get('accessValue').value) {
      this.addNewFormAccessValueSubscription = this.formsTurnsService.addNewFormAccessValue(this.form.InternalId, this.accessListForm.get('accessValue').value).subscribe(
        (res) => {
          this.snackbarService.open(res['message'], 'success');
          this.accessListForm.patchValue({
            accessValue: null
          });
          this.formsTurnsService.refreshForm();
        },
        (error) => {
          this.snackbarService.open(error['message'], 'error');
          this.formsTurnsService.refreshForm();
        }
      );
    }
  }
  public deleteAccessListKey(accessValue) {
    this.addNewFormAccessValueSubscription = this.formsTurnsService.deleteNewFormAccessValue(accessValue.InternalId).subscribe(
      (res) => {
        this.snackbarService.open(res['message'], 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['message'], 'error');
        this.formsTurnsService.refreshForm();
      }
    );
  }

  private resetForm() {
    this.accessListForm.patchValue({
      accessListEnable: this.form.AccessListEnable,
      checkListUserAccount: this.form.CheckListUserAccount
    });
    if (!this.accessListForm.get('accessListEnable').value) {
      this.accessListForm.get('checkListUserAccount').disable();
    } else {
      this.accessListForm.get('checkListUserAccount').enable();
    }
  }

  ngOnDestroy() {
    if (this.updateAccessListFormSubscription) { this.updateAccessListFormSubscription.unsubscribe(); }
    if (this.addNewFormAccessValueSubscription) { this.addNewFormAccessValueSubscription.unsubscribe(); }
  }

}
